import { Star } from 'lucide-react';
import { getAverageRating } from '@/data/reviewsData';

export const StarRating = ({ slug, showCount = false }) => {
  const { avg, count } = getAverageRating(slug);
  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={`w-3 h-3 ${i <= Math.round(avg) ? 'fill-gold text-gold' : 'fill-muted text-muted'}`}
        />
      ))}
      <span className="text-xs text-muted-foreground ml-1">
        {avg}{showCount && count > 0 ? ` (${count})` : ''}
      </span>
    </div>
  );
};
